import { loadSwiper } from './swiper-loader.js';

if (!customElements.get('promo-bar')) {
    class PromoBar extends HTMLElement {
        #swiper = null;

        connectedCallback() {
            this.#init();
        }

        disconnectedCallback() {
            this.#destroySwiper();
        }

        async #init() {
            const elSlides = this.querySelectorAll('.swiper-slide');
            const enabled = elSlides.length > 1;
            const autoplayDelay = Number(this.getAttribute('autoplay-delay') || 10) * 1000;

            const Swiper = await loadSwiper();

            this.#destroySwiper();

            // Reveal all slides before init so Swiper measures the real
            // layout. Vertical mode needs the laid-out slide heights to build
            // its snap grid; measuring them while hidden breaks autoplay.
            this.setAttribute('data-swiper-ready', '');

            this.#swiper = new Swiper(this, {
                enabled,
                loop: enabled,
                direction: 'vertical',
                slidesPerView: 1,
                speed: 500,
                autoplay: enabled ? {
                    delay: autoplayDelay,
                    disableOnInteraction: false,
                } : false,
            });
        }

        #destroySwiper() {
            if (!this.#swiper) {
                return;
            }

            this.#swiper.destroy(true, true);
            this.#swiper = null;
        }
    }

    customElements.define('promo-bar', PromoBar);
}

const GLOBALE_BANNER_ID = 'FreeShippingBanner';

const syncGlobaleBannerHeight = () => {
    if (document.querySelector('promo-bar')) {
        return;
    }

    const root = document.documentElement;
    let resizeObserver = null;
    let observed = null;

    const layoutBoxFor = (banner) => {
        return banner.closest('.ge-free-shipping-container') || banner;
    };

    const applyHeight = (element) => {
        const height = Math.max(0, Math.round(element.getBoundingClientRect().height));
        root.style.setProperty('--promo-height', `${height}px`);
    };

    const detach = () => {
        resizeObserver?.disconnect();
        resizeObserver = null;

        if (observed) {
            observed.removeAttribute('data-promo-banner');
        }

        observed = null;
        root.style.removeProperty('--promo-height');
    };

    const attach = (banner) => {
        const element = layoutBoxFor(banner);

        if (observed === element) {
            return;
        }

        if (observed) {
            observed.removeAttribute('data-promo-banner');
        }

        if (!element.closest('header')) {
            element.setAttribute('data-promo-banner', '');
        }

        resizeObserver?.disconnect();
        observed = element;
        resizeObserver = new ResizeObserver(() => applyHeight(element));
        resizeObserver.observe(element);
        applyHeight(element);
    };

    const sync = () => {
        const banner = document.getElementById(GLOBALE_BANNER_ID);

        if (banner) {
            attach(banner);
            return;
        }

        if (observed) {
            detach();
        }
    };

    sync();

    const mutationObserver = new MutationObserver(sync);

    mutationObserver.observe(document.body, {
        childList: true,
        subtree: true,
    });
};

syncGlobaleBannerHeight();
